import ConnectDiscordContainer from './ConnectDiscord.container';
import ConnectDiscord from './ConnectDiscord';
export default ConnectDiscordContainer(ConnectDiscord);

//# sourceMappingURL=index.js.map